import * as React from 'react';
import { Box, Typography } from '@material-ui/core';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CustomDialog from './CustomDialog';

const useStyles = makeStyles((theme: Theme) => ({
  title: { display: 'inline-flex', alignItems: 'center', gap: 8 },
  icon: { color: theme.palette.warning.main },
  message: { color: theme.palette.grey[500], marginBottom: 12 },
  info: {
    background: theme.palette.grey[100],
    borderRadius: 6,
    padding: '8px 12px',
    color: theme.palette.text.primary
  }
}));

export interface QuantityWarningDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  /** Highlighted detail row (e.g. the entered quantity). */
  info: { label: string; value: React.ReactNode } | null;
}

// Reusable "high quantity" warning modal — warning glyph + a highlighted detail row,
// on the fleet theme via CustomDialog. Distinct from the plain yes/no ConfirmDialog.
const QuantityWarningDialog: React.FC<QuantityWarningDialogProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onClose,
  info
}) => {
  const c = useStyles();

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      maxWidth="xs"
      cancelLabel={cancelLabel}
      confirmLabel={confirmLabel}
      title={
        <Box component="span" className={c.title}>
          <WarningRoundedIcon className={c.icon} />
          {title}
        </Box>
      }
    >
      <Typography variant="body2" className={c.message}>
        {message}
      </Typography>
      {info && (
        <Box className={c.info}>
          <strong>{info.label}:</strong> {info.value}
        </Box>
      )}
    </CustomDialog>
  );
};

export default QuantityWarningDialog;
